import { NgModule } from '@angular/core';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MenuComponent } from './components/menu/menu.component';

@NgModule({
  declarations: [],
  imports: [MenuComponent, MenuItemComponent],
  exports: [MenuComponent, MenuItemComponent],
})
export class MenuModule {}
